import fontawesome from '@fortawesome/fontawesome'
import { faEnvelope } from '@fortawesome/fontawesome-free-solid'
import {fab, faTwitterSquare, faFacebook, faInstagram, faYoutube, faLinkedin, faQuora, faGithub, faFacebookMessenger} from "@fortawesome/free-brands-svg-icons";
// import { solid, regular, brands, icon } from '@fortawesome/fontawesome-svg-core/import.macro';

function initFontAwesome() {
    fontawesome.library.add(fab, faEnvelope, faTwitterSquare, faFacebook, faInstagram, faYoutube, faQuora, faLinkedin, faGithub, faFacebookMessenger);
}
export default initFontAwesome;